import { FC, useMemo, useState } from "react";
import { SuccinctPlan } from "@vviinn/user-managment-client-ts";

import { DynamicFormCardWrapperProps } from "./components/DynamicFormCardWrapper";
import { startEndDate } from "./components/startEndDate";
import { SubtitleItem } from "../../../components/GeneralUI/DetailedCardComponents";
import { Restricted } from "../../../components/Restricted";
import { CompanyPricingItem } from "./components/CompanyPricingItem";
import { ChevronIcon } from "../../../components/GeneralUI";
import { getCompanyAllPlans, useAppSelector } from "../../../store";
import { useRequestHandlers } from "../../../app/hooks/useRequestHandlers";

const planDataToCard = ({
  action,
  name,
  startDate,
  endDate,
  isActive,
}: SuccinctPlan): DynamicFormCardWrapperProps => ({
  title: name,
  subtitles: [
    {
      type: "text",
      text: startEndDate(startDate, endDate),
    },
  ] as SubtitleItem[],
  navigateUrl:
    action.navigateUrl ??
    `/company/${action.parameters.form.companyId}/contract/${action.parameters.form.contractId}/${action.formType}/${action.parameters.form.id}/`,
  enabled: !!isActive,
  textAtRight: isActive ? "Active" : "Inactive",
});

const sortPlans = (item1: SuccinctPlan, item2: SuccinctPlan) =>
  item1.isActive ? -1 : item2.isActive ? 1 : -1;

export const Plans: FC<{}> = () => {
  const plans = useAppSelector((state) => state.company.company?.plans);
  const currentCompanyId = useAppSelector((state) => state.company.company?.id);

  const [allPlansFetching, setAllPlansFetching] = useState<boolean>(false);
  const [allPlansLoaded, setAllPlansLoaded] = useState(false);
  const { getApi, dispatch } = useRequestHandlers();

  const loadAllPlans = async () => {
    if (
      plans?.showAll ||
      allPlansLoaded ||
      !currentCompanyId ||
      !plans?.actions.showAll
    )
      return;
    const api = await getApi();
    setAllPlansFetching(true);
    const requestResult = await dispatch(
      getCompanyAllPlans({
        api,
        value: { companyId: currentCompanyId, action: plans.actions.showAll },
      }),
    );
    if (requestResult) {
      setAllPlansLoaded(true);
    }
    setAllPlansFetching(false);
  };

  const plansCardsData = useMemo(
    () =>
      [...(plans?.items ?? [])].sort(sortPlans).map((plan) => ({
        ...planDataToCard(plan),
        iconAtRight: <ChevronIcon />,
      })),
    [plans?.items],
  );

  return (
    <Restricted permissions="company:plans:view">
      <CompanyPricingItem
        initShowAll={plans?.showAll}
        itemCreateAction={plans?.actions.create}
        type="plans"
        cardsData={plansCardsData}
        filterData={(cardsData) => cardsData.filter(({ enabled }) => !!enabled)}
        warning={plans?.warning}
        showAllButton={
          plans?.actions?.showAll
            ? {
                disabled: allPlansFetching,
                handleShow: loadAllPlans,
              }
            : undefined
        }
      />
    </Restricted>
  );
};
